export const SWITCHBOARD_GROUPS = [
  { id: "all", name: "Tất cả" },
  { id: "cskh", name: "Tổng đài CSKH" },
  {
    id: "postoffice",
    name: "Tổng đài bưu cục",
  },
  {
    id: "postman",
    name: "Tổng đài bưu tá",
  },
];

export const LIST_CHAT_CHANNEL = [
  { id: "fb", name: "Facebook", value: "facebook" },
  { id: "zl", name: "Zalo", value: "zalo" },
  { id: "vb", name: "Viber", value: "viber" },
  { id: "wc", name: "Website", value: "web" },
];

export const LIST_CHAT_AGENT_STATUS = [
  {
    id: "agentOnline",
    chatAgentsId: "all",
    variant: "online",
    title: "Trực tuyến",
  },
  {
    id: "agentReadyChat",
    chatAgentsId: "service",
    variant: "ready",
    title: "Sẵn sàng",
  },
  {
    id: "agentChatting",
    chatAgentsId: "chatting",
    variant: "working",
    title: "Đang nhận chat",
  },
  {
    id: "agentBusy",
    chatAgentsId: "busy",
    variant: "busy",
    title: "Bận",
  },
  {
    id: "agentPause",
    chatAgentsId: "pause",
    variant: "pause",
    title: "Tạm nghỉ",
  },
  {
    id: "agentEatting",
    chatAgentsId: "eating",
    variant: "eating",
    title: "Ăn ca",
  },
];

export const ALL_OPTION = { label: "Tất cả", value: "all" };

export const LIST_INBOUND_CALL_STATUS = [
  {
    value: "answered",
    label: "Trả lời (Answered)",
  },
  { value: "missed", label: "Nhỡ (Missed)" },
  {
    value: "missedNoExtension",
    label: "Nhỡ (Missed no extension)",
  },
  { value: "ivr", label: "IVR" },
  {
    value: "rejected",
    label: "Từ chối (Rejected)",
  },
  { value: "skipped", label: "Bỏ qua (Skipped)" },
];
export const LIST_OUTBOUND_CALL_STATUS_V2 = [
  {
    value: "answered",
    label: "Trả lời",
  },
  { value: "no-answered", label: "Không trả lời" },
  { value: "busy", label: "Bận" },
  { value: "pending", label: "Thao tác người dùng" },
  { value: "exterror", label: "Lỗi máy lẻ" },
  { value: "telerror", label: "Lỗi nhà mạng" },
  { value: "error", label: "Lỗi tổng đài" },
];
export const LIST_INBOUND_CALL_STATUS_V2 = [
  {
    value: "answered",
    label: "Trả lời",
  },
  { value: "no-answered", label: "Không trả lời" },
  { value: "busy", label: "Bận" },
  { value: "skipped", label: "Chuyển tiếp" },
  { value: "IVR", label: "IVR" },
  { value: "error", label: "Lỗi tổng đài" },
];

export const LIST_OUTBOUND_CALL_STATUS = [
  { value: "answered", label: "Trả lời" },
  { value: "busy", label: "Bận" },
  { value: "no-answered", label: " Không trả lời" },
];

export const LIST_ANSWERED_DURATION = [
  { value: "-1", label: "Cuộc gọi nhỏ hơn 1 phút" },
  {
    value: "1-3",
    label: "Cuộc gọi từ 1 phút đến 3 phút",
  },
  {
    value: "3-5",
    label: "Cuộc gọi từ 3 phút đến 5 phút",
  },
  {
    value: "5-10",
    label: "Cuộc gọi từ 5 phút đến 10 phút",
  },
  { value: "10-", label: "Cuộc gọi lớn hơn 10 phút" },
];

export const ANSWERED_DURATION_OPTION = [
  { value: "0,60", label: "Cuộc gọi nhỏ hơn 1 phút" },
  {
    value: "60,180",
    label: "Cuộc gọi từ 1 phút đến 3 phút",
  },
  {
    value: "180,300",
    label: "Cuộc gọi từ 3 phút đến 5 phút",
  },
  {
    value: "300,600",
    label: "Cuộc gọi từ 5 phút đến 10 phút",
  },
  { value: "600,9999", label: "Cuộc gọi lớn hơn 10 phút" },
];

export const DEPARTMENT_QUEUE_TYPES = {
  CSKH: {
    value: 5,
    title: "CSKH",
    titleValue: "CSKH",
  },
};

export const BUSINESS_PHONE_NUMBER_TYPES = [
  { label: "Gọi vào", value: "in" },
  { label: "Gọi ra", value: "out" },
];

export const BUSINESS_TELECOM_OPERATORS = [
  { label: "Viettel", value: "viettel" },
  { label: "Vina", value: "gpc" },
  { label: "Mobiphone", value: "vms" },
];

export const OUTBOUND_CALL_STATUS_OPTIONS = [
  {
    label:
      "Gọi ra Khách hàng ấn bận -  Gọi ra khách hàng đang bận trong cuộc gọi khác",
    value: "Busy",
  },
  { label: "Gọi ra điện thoại viên ngắt máy trước", value: "CallerCancel" },
  { label: "Gọi ra hết thời gian chờ", value: "Timeout" },
  {
    label: "Gọi ra khách hàng nghe máy - Khách hàng ngắt máy trước",
    value: "CalleeHangup",
  },
  {
    label: "Gọi ra khách hàng nghe máy - ĐTV ngắt máy trước",
    value: "CallerHangup",
  },
  {
    label: "Gọi ra thuê bao hoặc bị chặn",
    value: "Unavailable",
  },
  {
    label: "Telco lỗi",
    value: "Error",
  },
  {
    label: "Sip phone ấn ngắt máy",
    value: "pending-busy",
  },
  {
    label: "Sip phone không nghe máy để tự ngắt",
    value: "pending-timeout",
  },
  {
    label: "Sip phone bị treo - Sip phone không register",
    value: "pending-error",
  },
];
export const CALL_FLOW_STATUS_OPTIONS = [
  {
    label: "Chờ phê duyệt",
    value: "waiting",
  },
  {
    label: "Đã phê duyệt",
    value: "done",
  },
];
// contactCode;
export const TYPE_PBX_OPTIONS = [
  {
    label: "Tổng đài bưu cục phát",
    value: "bcp",
  },
  {
    label: "Tổng đài CSKH",
    value: "cskh",
  },
  {
    label: "Tổng đài lực lượng bán",
    value: "llb",
  },
  {
    label: "Cuộc gọi từ MyVietNamPost",
    value: "myvietnampost",
  },
  {
    label: "Cuộc gọi từ Call Me Ding Dong",
    value: "callmedingdong",
  },
];
export const CALL_TIME_OPTIONS = [
  {
    label: "Cả ngày",
    value: "",
  },
  {
    label: "Theo giờ làm việc",
    value: "on-time",
  },
  {
    label: "Ngoài giờ làm việc",
    value: "out-time",
  },
];

export const BUSINESS_BCP_VALUE = "business-BCP";
export const BUSINESS_CSKH_VALUE = "business-CSKH";

export const BUSINESS_REPORT_OPTIONS = [
  {
    label: "Báo cáo kinh doanh Bưu cục phát",
    value: BUSINESS_BCP_VALUE,
  },
  {
    label: "Báo cáo kinh doanh CSKH",
    value: BUSINESS_CSKH_VALUE,
  },
];
export const OPEN_STATUS_VALUE = "Open";
export const CLOSED_VALUE = "Closed";
export const STATUS_TICKET_OPTIONS = [
  {
    label: "Open",
    value: OPEN_STATUS_VALUE,
  },
  {
    label: "Closed",
    value: CLOSED_VALUE,
  },
];

export const LIST_DAY = [
  {
    label: "Thứ 2",
    value: 1,
  },
  {
    label: "Thứ 3",
    value: 2,
  },
  {
    label: "Thứ 4",
    value: 3,
  },
  {
    label: "Thứ 5",
    value: 4,
  },
  {
    label: "Thứ 6",
    value: 5,
  },
  {
    label: "Thứ 7",
    value: 6,
  },
  {
    label: "Chủ nhật",
    value: 0,
  },
];

export const LIST_CALL_TYPE = [
  { label: "Gọi vào", value: "inbound" },
  { label: "Gọi ra", value: "outbound" },
];

export const LIST_NETWORK_TYPE = [
  { label: "Nội mạng", value: "on-net" },
  { label: "Ngoại mạng", value: "off-net" },
];

export const LIST_GROUP_LEVEL = [
  { label: "Nhóm theo cấp BĐT/TP", value: "BDT" },
  { label: "Nhóm theo cấp BĐH", value: "BDH" },
  { label: "Nhóm theo cấp Bưu cục", value: "BC" },
];
